"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentState = exports.PageState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const store_1 = require("../store");
const collection_edit_state_1 = require("./collection.edit.state");
const collection_link_state_1 = require("./collection.link.state");
const tag_selection_state_1 = require("./tag.selection.state");
class PageState {
    constructor() {
        this.Tag = new tag_selection_state_1.TagSelectionState(this);
        this.CollectionLink = new collection_link_state_1.CollectionLinkState();
        this.isGoogleMapsLoaded = false;
        this.isCtrlShiftPressed = false;
        this.hoverId = null;
        this.inspectedTagId = null;
        this.inspectedCollectionRevision = null;
        this.inspectedCaptureId = null;
        this.inspectedFieldId = null;
        this.expandedTagId = null;
        this._lastEditState = new collection_edit_state_1.CollectionEditState(null);
        this.reset();
    }
    setIsCtrlShiftPressed(selected) {
        this.isCtrlShiftPressed = selected;
    }
    get CollectionEdit() {
        if (this._lastEditState.collectionRevision === this.inspectedCollectionRevision) {
            return this._lastEditState;
        }
        if (this.inspectedCollectionRevision == null) {
            this._lastEditState = new collection_edit_state_1.CollectionEditState(null);
            return this._lastEditState;
        }
        const collection = store_1.AppStore.Collection.get(this.inspectedCollectionRevision);
        if (collection == null) {
            this._lastEditState = new collection_edit_state_1.CollectionEditState(null);
            return this._lastEditState;
        }
        this._lastEditState = new collection_edit_state_1.CollectionEditState(collection);
        return this._lastEditState;
    }
    clearSelected() {
        this.inspectedCaptureId = null;
        this.inspectedCollectionRevision = null;
        this.inspectedTagId = null;
        this.expandedTagId = null;
        this.Tag.reset();
    }
    setHoverId(hoverId) {
        this.hoverId = hoverId;
    }
    setInspectedTagId(tagId) {
        this.inspectedTagId = tagId;
    }
    setExpandedTagId(tagId) {
        this.expandedTagId = tagId;
    }
    setInspectedCollection(revision, captureId = null) {
        const lastRevision = this.inspectedCollectionRevision;
        const lastCapture = this.inspectedCaptureId;
        this.inspectedCollectionRevision = revision;
        this.inspectedCaptureId = captureId;
        if (revision) {
            const summary = store_1.AppStore.CollectionSummary.get(revision);
            if (summary != null) {
                const firstTagId = summary.tags[0];
                this.setExpandedTagId(firstTagId !== null && firstTagId !== void 0 ? firstTagId : null);
                this.setInspectedTagId(firstTagId !== null && firstTagId !== void 0 ? firstTagId : null);
            }
            // Reset the linking field state on capture change.
            if (lastRevision === revision && lastCapture !== captureId && lastCapture != null) {
                this.CollectionEdit.cancelLinkFields();
            }
        }
        this.CollectionLink.cancelLinking();
    }
    setInspectedFieldId(fieldId) {
        this.inspectedFieldId = fieldId;
    }
    cancelInteractions() {
        this.CollectionEdit.cancelLinkFields();
        this.CollectionLink.cancelLinking();
    }
    updateInspectedCollection() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.inspectedCollectionRevision == null) {
                return;
            }
            const summary = store_1.AppStore.CollectionSummary.get(this.inspectedCollectionRevision);
            if (summary == null) {
                this.setInspectedCollection(null);
                return;
            }
            const latestSummary = yield store_1.AppStore.CollectionSummary.getFetchableByUuid(summary.uuid).refetch();
            if (latestSummary == null || latestSummary.revision === summary.revision) {
                return;
            }
            this.setInspectedCollection(latestSummary.revision, this.inspectedCaptureId);
        });
    }
    setInspectedCollectionFailed() {
        this.setInspectedCollection(null);
    }
    setGoogleMapsLoaded() {
        this.isGoogleMapsLoaded = true;
    }
    reset() {
        this.hoverId = null;
        this.inspectedCaptureId = null;
        this.inspectedCollectionRevision = null;
        this.inspectedTagId = null;
        this.expandedTagId = null;
        this.Tag.reset();
        this.CollectionLink.discardAllModifiedTargets();
        this.CollectionLink.cancelLinking();
    }
}
exports.PageState = PageState;
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "isGoogleMapsLoaded", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "isCtrlShiftPressed", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "hoverId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "inspectedTagId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "inspectedCollectionRevision", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "inspectedCaptureId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "inspectedFieldId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], PageState.prototype, "expandedTagId", void 0);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setIsCtrlShiftPressed", null);
tslib_1.__decorate([
    mobx_1.computed
], PageState.prototype, "CollectionEdit", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "clearSelected", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setHoverId", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setInspectedTagId", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setExpandedTagId", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setInspectedCollection", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setInspectedFieldId", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setInspectedCollectionFailed", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "setGoogleMapsLoaded", null);
tslib_1.__decorate([
    mobx_1.action
], PageState.prototype, "reset", null);
exports.CurrentState = new PageState();
//# sourceMappingURL=page.state.js.map